<div class="toolbar bold" #toolbarContainer="" [ngStyle]='{ "background-color": bg  }'>
  <div class="leftIcon" [ngStyle]='{ "color": leftIconColor }'>
    @if (enableMenu) {
      <em class="cs-icon-menu font25" rippleEffect="rippleEffect" (callback)="onAction.emit()" rippleClass="ripple-white"></em>
      }@if (!enableMenu && !disableBack) {
      <em class="cs-icon-back-arrow" rippleEffect="rippleEffect" (callback)="onAction.emit()" rippleClass="ripple-white"></em>
    }
  </div>
  <div class="title ellipsis"><ng-content></ng-content></div>
  @if (icons.length && icons[0].name === appConfig.Toolbar.ICONS.DELETE) {
    <div class="rightIcon" [color]='"#fff"' loadingEffect="loadingEffect" [timeout]="3000" [bgClass]='"bg-primary"'>
      @if (icons.length) {
        <div class="flex justify-center" rippleEffect="rippleEffect" rippleClass="ripple-white">
          @if (icons[0].name === appConfig.Toolbar.ICONS.DELETE) {
            <em class="cs-icon-delete font22" (click)="onClick(icons[0])"></em>
          }
        </div>
      }
    </div>
  }
  @if (icons.length && icons[0].name !== appConfig.Toolbar.ICONS.DELETE) {
    <div class="rightIcon" [attr.data-after]="icons[0].cartValue" [ngClass]='{ "notify": icons[0].notify && !icons[1]?.cartValue , "cartCart": icons[0].cartValue && icons[0].showCartUI, "cartHome": icons[1]?.homePage && icons[1]?.showCartUI && icons[1].cartValue, "notify2": icons[0].notify && icons[1]?.showCartUI && icons[1]?.cartValue }'>
      @if (icons.length) {
        <div class="flex justify-center" rippleEffect="rippleEffect" rippleClass="ripple-white">
          @if (icons[0].name === appConfig.Toolbar.ICONS.LOCK) {
            <em class="cs-icon-lock font22" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.EDIT) {
            <em class="cs-icon-edit font20" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.SAVE) {
            <em class="cs-icon-tick font20" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.CALL) {
            <em class="cs-icon-phone-in-talk font20" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.INFO) {
            <em class="cs-icon-info font22" (click)="onClick(icons[0])"></em>
          }
          @if (icons[1]?.name === appConfig.Toolbar.ICONS.CART && icons[1]?.showCartUI && icons[1]?.cartValue) {
            <div class="doubleIcon" [attr.data-after]="icons[1]?.cartValue" (click)="onClick(icons[1])" [ngClass]='{ "checkData": icons[1]?.cartValue }'>
              @if (icons[1]?.name === appConfig.Toolbar.ICONS.CART && icons[1]?.showCartUI && icons[1]?.homePage) {
                <img class="cartIcon" src="/assets/images/cart.png" />
              }
            </div>
          }
          @if (icons[0].name === appConfig.Toolbar.ICONS.NOTIFICATION) {
            <em class="cs-icon-notification" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.REFRESH) {
            <em class="cs-icon-refresh" (click)="onClick(icons[0])"></em>
            }@if (icons[0].name === appConfig.Toolbar.ICONS.CART && icons[0].showCartUI && icons[0].cartValue) {
            <img class="cartIcon" src="/assets/images/cart.png" (click)="onClick(icons[0])" />
          }
        </div>
      }
    </div>
  }
</div>